import { render, staticRenderFns } from "./RegisterIndividualToTeam.vue?vue&type=template&id=37a8fa82&scoped=true"
import script from "./RegisterIndividualToTeam.vue?vue&type=script&lang=js"
export * from "./RegisterIndividualToTeam.vue?vue&type=script&lang=js"
import style0 from "./RegisterIndividualToTeam.vue?vue&type=style&index=0&id=37a8fa82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8fa82",
  null
  
)

export default component.exports